import React, { useEffect, useState, useMemo } from "react";
import AdapterMoment from "@mui/lab/AdapterMoment";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import {
    TextField,
    FormControl,
    FormHelperText,
} from "@mui/material";
import DatePicker from "@mui/lab/DatePicker";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import moment from 'moment';
import { currentLanguage } from "service/CommonFunction/AxiosConfig";
const localeMap = {
    en: moment.locale("en"),
    th: moment.locale("th"),
};

const maskMap = {
    en: "DD/MM/YYYY",
    th: "DD/MM/YYYY",
};

export default function DatePickerFormItem(props) {
    const {
        name,
        required,
        disabled,
        onChange,
        label,
        labelString,
        fullWidth,
        minDate,
        maxDate,
        small,
        format,
        view,
        shouldDisableDate,
        shouldDisableYear
    } = props;

    const {
        register,
        setValue,
        watch,
        getValues,
        formState: { errors },
    } = useFormContext();

    const ReplaceThFormat = (text) => {
        return text.toLowerCase().replaceAll("d", "ว").replaceAll("m", "ด").replaceAll("y", "ป");
    }

    const formatDefalut = format;
    const maskMap = {
        en: formatDefalut,
        th: ReplaceThFormat(formatDefalut),
    };

    const [locale, setLocale] = React.useState<keyof typeof maskMap>("th");

    const [objCheckReplace] = useState(() => {
        let objReturn = { isReplaceYear: false, indexArr: 0, splitText: "" };
        var formatLower = formatDefalut.toLowerCase();
        if (formatLower.includes("yyyy")) {
            var splitText = (formatDefalut.substr(formatLower.indexOf("yyyy") - 1, 1)).toLowerCase();
            if (splitText !== "y") {
                objReturn.splitText = splitText;
                objReturn.indexArr = formatLower.split(splitText).findIndex((e) => e === "yyyy");
            }
            objReturn.isReplaceYear = true;
        }
        return objReturn;
    });

    // useEffect(() => {
    //     let sLang : 'th' | 'en' = currentLanguage() == "th" ? "th" : "en";
    //     setLocale(sLang)
    // }, [])
    

    return (
        <LocalizationProvider
            // locale={locale}
            // CustomAdapter
            locale={"th"}
            dateAdapter={CustomAdapter}
        >
            <FormControl
                sx={{
                    "label.MuiInputLabel-shrink": {
                        backgroundColor: "rgba(255,255,255,0.95)",
                        top: "0px",
                    },
                    ".MuiInputLabel-outlined": {
                        top: "0px",
                    },
                    ".MuiInputLabel-asterisk": {
                        color: "red"
                    },
                      ".Mui-disabled": {
                        backgroundColor: "#f1f1f1",
                        color: "#000000"
        
                      },
                }}
            >
                <DatePicker
                    inputRef={register(name).ref}
                    {...register(name)}
                    value={watch(name) || null}
                    onChange={(e, key) => {
                        let dInfo: Date = e;
                        if (locale === "th") {
                            if (key) {
                                if (key.length == 10) {
                                    let year = key.substring(6, 10);
                                    dInfo = parseInt(year) > 2500 ? new Date(moment(e).add(-543, 'year').valueOf()) : e
                                }
                            }
                        }
                        setValue(name, dInfo, { shouldValidate: true });
                        onChange && onChange(dInfo);
                    }}
                    minDate={minDate || null}
                    maxDate={maxDate || null}
                    label={label}
                    shouldDisableDate={shouldDisableDate}
                    shouldDisableYear={shouldDisableYear}
                    inputFormat={formatDefalut}
                    disabled={disabled || false}
                    showToolbar={false}
                    views={view}
                    renderInput={(props) => {
                        props.inputProps.placeholder = maskMap[locale];

                        if (locale === "th") {
                            if (props.inputProps.value && objCheckReplace.isReplaceYear && props.inputProps.value.length == 10) {
                                let year = objCheckReplace.splitText ? props.inputProps.value.split(objCheckReplace.splitText)[objCheckReplace.indexArr] : props.inputProps.value.substr(0, 4);
                                let addyear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
                                props.inputProps.value = props.inputProps.value.replaceAll(`${year}`, `${addyear}`);   //ปิดเพราะทำให้พิมพ์แล้ว error

                            } else if (format === "YYYY" && props.inputProps.value && objCheckReplace.isReplaceYear && props.inputProps.value.length == 4) {
                                let addyear = parseInt(props.inputProps.value) > 2500 ? parseInt(props.inputProps.value) : parseInt(props.inputProps.value) + 543;
                                props.inputProps.value = addyear;

                            } else if (format === "MM/YYYY" && props.inputProps.value && objCheckReplace.isReplaceYear) {
                                let year = objCheckReplace.splitText ? props.inputProps.value.split(objCheckReplace.splitText)[1] : props.inputProps.value.substr(0, 2);
                                let addyear = year > 2500 ? parseInt(year) : parseInt(year) + 543;
                                props.inputProps.value = props.inputProps.value.replaceAll(`${year}`, `${addyear}`);
                            }
                        }

                        return (
                            <TextField
                                {...props}
                                sx={{
                                    ".MuiOutlinedInput-root": {
                                        padding: "0px 15px 0px 0px!important",
                                        " fieldset > legend > span": {
                                            padding: "0px !important",
                                        },
                                    },
                                    "label.MuiInputLabel-shrink": {
                                        backgroundColor: "rgba(255,255,255,0.95)",
                                        top: "0px",
                                      },
                                      ".MuiInputLabel-outlined": { 
                                        top: "0px",
                                      },
                                      ".MuiInputLabel-asterisk": {
                                        color: "red"
                                      },
                                      ".Mui-disabled": {
                                        // backgroundColor: "#d9d9d9",
                                        color: "#000000"
                        
                                      },
                                    fontWeight: 600,
                                }}
                                size={small ? "small" : "medium"}
                                label={label}
                                fullWidth={fullWidth}
                                name={name}
                                error={Boolean(errors[name])}
                                required={required || false}
                                disabled={disabled || false}
                                value={watch(name) || ""}
                                autoComplete={"off"}
                            />
                        )
                    }}
                />
                {errors && errors[name] ? (
                    <FormHelperText sx={{ color: "red" }}>
                        {errors[name].message}
                    </FormHelperText>
                ) : null}
            </FormControl>
        </LocalizationProvider>
    );
}

DatePickerFormItem.defaultProps = {
    fullWidth: true,
    format: "DD/MM/YYYY",
    small: true,
};

DatePickerFormItem.propTypes = {
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.any,
    labelString: PropTypes.any,
    fullWidth: PropTypes.bool,
    minDate: PropTypes.any,
    maxDate: PropTypes.any,
    small: PropTypes.bool,
    format: PropTypes.string,
    view: PropTypes.array,
    shouldDisableDate: PropTypes.any,
    shouldDisableYear: PropTypes.any,
};



class CustomAdapter extends AdapterMoment {
    // REF : https://th-samranrit0193.medium.com/reactjs-materialui-buddhist-era-%E0%B8%9B%E0%B8%B5-%E0%B8%9E-%E0%B8%A8-1f293af00382
    constructor({ locale, formats, instance }) {
        super({ locale, formats, instance });
    }

    renderLabel(moment, format) {
        switch (format) {
            case "year":
                var checkYear = this.locale === "th" ? (parseInt(moment.format('YYYY')) + 543).toString() : parseInt(moment.format('YYYY'));
                return moment.format(checkYear);
            case "month":
                return moment.format("MMMM");
            case "dayOfMonth":
                return moment.format("D");
            case "monthShort":
                return moment.format("MMM");
            default:
                return moment.format(format);
        }
    }

    format = (date, formatKey) => {
        return this.renderLabel(date, formatKey);
    };
}